import React, { useState, useEffect } from 'react';
import { CheckCircleOutlined, ExclamationCircleOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { FaRegSave } from "react-icons/fa";
import { IoSave } from "react-icons/io5";
import './style.css';

const AutosaveIndicator = ({ status, error, floating }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let timer;
    if (status === 'success') {
      setVisible(true);
      timer = setTimeout(() => setVisible(false), 2000);
    } else if (status === 'saving' || status === 'error') {
      setVisible(true);
    } else if (status === 'idle') {
      setVisible(false);
    }

    return () => clearTimeout(timer);
  }, [status]);

  if (!visible && status !== 'idle' && !floating) {
    return null;
  }

  const getIndicator = () => {
    switch (status) {
      case 'saving':
        return (
          <div className="autosave-indicator saving">
            {/* <CloudUploadOutlined className="pulsing-icon" /> */}
            <IoSave />
            <span>Saving...</span>
          </div>
        );
      case 'success':
        return (
          <div className="autosave-indicator success">
            <CheckCircleOutlined />
            <span>Saved</span>
          </div>
        );
      case 'error':
        return (
          <Tooltip title={error?.message || 'An error occurred'}>
            <div className="autosave-indicator error">
              <ExclamationCircleOutlined />
              <span>Error</span>
            </div>
          </Tooltip>
        );
      case 'idle':
        return (
            <div className="autosave-indicator idle">
              <FaRegSave />
            </div>
        )
      default:
        return null;
    }
  };

    let containerClassName = `autosave-container ${floating ? 'float' : ''}`;
  if (floating && status === 'idle') {
    containerClassName += ' small';
  }

  const container = <div className={containerClassName}>{getIndicator()}</div>;

  // Don't show the tooltip if there's an error, as the error has its own tooltip.
  if (status === 'error') {
    return container;
  }

  return (
    <Tooltip title={<span className="tooltip-center">Your work is automatically saved!</span>} arrow>
      {container}
    </Tooltip>
  );
};

export default AutosaveIndicator;